import type { LegalAgreement } from "@/Modules/Models/Domain/LegalAgreement";
import type { CustomerStore } from "@/Modules/Customers/Store";

import { acceptAndSendAllLegalAgreements } from "@/Services/TherapyApi/LegalAgreements";

import useCustomerStore from "@/Modules/Customers/Store";

import { hasValue } from "@/Utils/Objects";
import { danger } from "@/Utils/Debug";

class SendAllLegalAgreementsToPatientActionHandler {
  constructor(private readonly store: CustomerStore = useCustomerStore()) {}

  public async handle(patientId: string, therapistId: string): Promise<LegalAgreement[] | undefined> {
    try {
      const legalAgreements = await acceptAndSendAllLegalAgreements(patientId, therapistId);

      if (
        hasValue(this.store.customers[patientId]) &&
        hasValue(this.store.customers[patientId].legalAgreements)
      ) {
        this.store.customers[patientId].legalAgreements = this.store.customers[patientId].legalAgreements.map(
          (la) => {
            const legalAgreementSigned = legalAgreements.find((laApi) => laApi.uuid === la.uuid);
            if (legalAgreementSigned) return legalAgreementSigned;
            return la;
          }
        );
      }

      return legalAgreements;
    } catch (e) {
      danger(e);
    }
  }
}

export default SendAllLegalAgreementsToPatientActionHandler;
